import { render, staticRenderFns } from "./ModalNotificacaoEmailProcessamento.vue?vue&type=template&id=657e514f"
import script from "./ModalNotificacaoEmailProcessamento.vue?vue&type=script&lang=ts"
export * from "./ModalNotificacaoEmailProcessamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports